// Lightweight i18n: kebab keys → translated strings (English, Hindi, Telugu).
export const LANGS = [
  { code: 'en', name: 'English', native: 'English' },
  { code: 'hi', name: 'Hindi', native: 'हिन्दी' },
  { code: 'te', name: 'Telugu', native: 'తెలుగు' },
];

const dict = {
  en: {
    app_name: 'BecAim AI',
    tagline: 'BECOME what you AIM',
    enter_phone: 'Enter your phone number',
    send_otp: 'Send OTP',
    verify: 'Verify',
    otp_label: 'Enter OTP',
    next: 'Next',
    back: 'Back',
    finish: 'Finish',
    skip: 'Skip',
    age_group: 'Select your age',
    gender: 'I am',
    occupation: 'What do you do?',
    goal_category: 'What area of life?',
    goal_specific: 'Pick your goal',
    custom_goal: 'Type your own goal',
    timeline: 'How long?',
    importance: 'How important is this?',
    your_mission: "Today's Mission",
    mark_complete: 'Mark Complete',
    skip_mission: 'Skip',
    reward: 'Reward',
    streak: 'Day Streak',
    coins: 'Coins',
    xp: 'XP',
    level: 'Level',
    feed: 'Feed',
    home: 'Home',
    coach: 'Coach',
    profile: 'Profile',
    friends: 'Friends',
    ask_coach: 'Ask your coach…',
    ask: 'Ask',
    badges: 'Badges',
    leaderboard: 'Leaderboard',
    achievements: 'Achievements',
    logout: 'Log out',
    upload_proof: 'Upload Proof (optional)',
    add_note: 'Add a note (optional)',
    confirm: 'Confirm',
    cancel: 'Cancel',
    completed: 'Completed!',
    earned_xp: 'You earned',
    next_mission_ready: 'Your next mission is ready',
    level_up: 'LEVEL UP!',
    new_post: "What's on your mind?",
    post: 'Post',
    no_posts: 'No posts yet. Be the first!',
    notifications: 'Notifications',
    admin: 'Admin',
    admin_panel: 'Admin Panel',
    users: 'Users',
    goals: 'Goals',
    missions: 'Missions',
    total_users: 'Total Users',
    active_7d: 'Active (7d)',
    dau: 'Daily Active',
    mission_pct: 'Mission %',
    broadcast: 'Broadcast',
    broadcast_send: 'Send Notification',
    edit_profile: 'Edit Profile',
    save: 'Save',
    theme_light: 'Light',
    theme_dark: 'Dark',
    theme_system: 'System',
    groups: 'Groups',
    display_name: 'Display name',
    privacy: 'Privacy',
    public: 'Public',
    friends_only: 'Friends only',
    private: 'Private',
    welcome_back: 'Welcome back',
    sign_in_signup: 'Sign in / Sign up',
    fast_easy: 'No password. Just your phone.',

    // Goal Detail + Edit modal (iter-17)
    goal_details: 'Goal details',
    edit: 'Edit',
    active_goal: 'Active goal',
    make_active: 'Make active',
    why_this_matters: 'Why this matters',
    extra_context: 'Extra context',
    active_mission: 'Active mission',
    no_active_mission: 'No active mission yet.',
    activate_this_goal: 'Activate this goal',
    open_on_dashboard: 'Open on Dashboard',
    mission_history: 'Mission history',
    no_completed_missions: 'No completed missions yet. Finish your first mission to see it here.',
    completed_label: 'Completed',
    skipped_label: 'Skipped',
    archive_goal: 'Archive this goal',
    archive_confirm: 'Archive this goal? Active mission will end.',
    goal_archived: 'Goal archived',
    failed_archive: 'Failed to archive',
    set_as_active: 'Set as active goal',
    failed_switch: 'Failed to switch',
    saved: 'Saved',
    saved_new_mission: 'Saved — coach generated a new mission',
    could_not_save: 'Could not save',
    could_not_load_goal: 'Could not load goal',
    edit_goal: 'Edit goal',
    title_label: 'Title',
    timeline_days_label: 'Timeline (days)',
    importance_label: 'Importance (1–10)',
    extra_details_label: 'Extra details for your AI coach',
    extra_details_placeholder: 'Anything new about your situation, schedule, constraints, etc.',
    reassess_checkbox: 'Re-assess and generate a fresh mission with these updates',
    reassess_hint: 'We always re-assess if you change details or timeline.',
    save_changes: 'Save changes',
    saving: 'Saving…',
    day_plan_short: 'day plan',
    tap_to_open_goal: 'Tap to edit · view completed missions →',
    diff: 'Diff',
    min_short: 'min',

    // AddGoalWizard (iter-32)
    addgoal_pick_area: 'Pick your area',
    addgoal_whats_goal: "What's the goal?",
    addgoal_tap_suggestion: 'Tap a suggestion or type your own',
    addgoal_title_placeholder: 'e.g. Walk 5,000 steps daily',
    addgoal_tell_me_more: 'Tell me more',
    addgoal_coach_needs_details: 'Your AI coach needs a few details to tailor your missions perfectly.',
    addgoal_coach_thinking: 'Your coach is thinking…',
    addgoal_personalising: 'Personalising questions…',
    addgoal_answer_placeholder: 'Your answer…',
    addgoal_how_long: 'How long?',
    addgoal_how_important: 'How important?',
    addgoal_out_of_10: 'out of 10',
    addgoal_create_goal: 'Create Goal',
    addgoal_generating_first: 'Generating your first mission…',
    addgoal_coach_reading: 'Your AI coach is reading your goal — this takes 5–10 seconds.',
    // Category macro groups
    cat_group_wellness: 'Wellness & Body',
    cat_group_money: 'Money & Career',
    cat_group_land: 'Land & Livelihood',
    cat_group_mind: 'Mind & Growth',
    cat_group_other: 'Anything Else',
    // Category labels (used by both wizard + feed filter)
    cat_health: 'Health',
    cat_fitness: 'Fitness',
    cat_business: 'Business',
    cat_sales: 'Sales',
    cat_money: 'Money',
    cat_savings: 'Savings',
    cat_education: 'Education',
    cat_career: 'Career',
    cat_relationships: 'Relations',
    cat_travel: 'Travel',
    cat_habits: 'Habits',
    cat_spiritual: 'Spiritual',
    cat_farming: 'Farming',
    cat_other: 'Other',
    // Farming suggestions (the user's primary use-case)
    sug_plan_season_crop: "Plan This Season's Crop",
    sug_prepare_the_land: 'Prepare The Land',
    sug_buy_seeds_inputs: 'Buy Seeds & Inputs',
    sug_sow_on_time: 'Sow / Transplant On Time',
    sug_apply_fertilizer: 'Apply Fertilizer Right',
    sug_manage_pests: 'Manage Pests & Diseases',
    sug_irrigate_smartly: 'Irrigate Smartly',
    sug_harvest_on_time: 'Harvest On Time',
    sug_better_selling_price: 'Get A Better Selling Price',
    sug_grow_farm_income: 'Grow Income From Farm',
  },
  hi: {
    app_name: 'BecAim AI',
    tagline: 'जो बनना है, वही पाओ',
    enter_phone: 'अपना मोबाइल नंबर डालें',
    send_otp: 'OTP भेजें',
    verify: 'सत्यापित करें',
    otp_label: 'OTP डालें',
    next: 'आगे',
    back: 'पीछे',
    finish: 'पूरा करें',
    skip: 'छोड़ें',
    age_group: 'अपनी उम्र चुनें',
    gender: 'मैं हूँ',
    occupation: 'आप क्या करते हैं?',
    goal_category: 'जीवन का कौन सा क्षेत्र?',
    goal_specific: 'अपना लक्ष्य चुनें',
    custom_goal: 'अपना लक्ष्य लिखें',
    timeline: 'कितना समय?',
    importance: 'यह कितना ज़रूरी है?',
    your_mission: 'आज का मिशन',
    mark_complete: 'पूरा हुआ',
    skip_mission: 'छोड़ें',
    reward: 'इनाम',
    streak: 'दिन की लड़ी',
    coins: 'सिक्के',
    xp: 'XP',
    level: 'लेवल',
    feed: 'फ़ीड',
    home: 'होम',
    coach: 'कोच',
    profile: 'प्रोफ़ाइल',
    friends: 'दोस्त',
    ask_coach: 'अपने कोच से पूछें…',
    ask: 'पूछें',
    badges: 'बैज',
    leaderboard: 'लीडरबोर्ड',
    achievements: 'उपलब्धियाँ',
    logout: 'लॉग आउट',
    upload_proof: 'सबूत अपलोड (वैकल्पिक)',
    add_note: 'नोट जोड़ें (वैकल्पिक)',
    confirm: 'पक्का',
    cancel: 'रद्द',
    completed: 'पूरा हुआ!',
    earned_xp: 'आपको मिले',
    next_mission_ready: 'आपका अगला मिशन तैयार है',
    level_up: 'लेवल अप!',
    new_post: 'क्या ख़याल है?',
    post: 'पोस्ट',
    no_posts: 'अभी कोई पोस्ट नहीं। पहले बनो!',
    notifications: 'सूचनाएँ',
    admin: 'एडमिन',
    admin_panel: 'एडमिन पैनल',
    users: 'यूज़र',
    goals: 'लक्ष्य',
    missions: 'मिशन',
    total_users: 'कुल यूज़र',
    active_7d: 'सक्रिय (7 दिन)',
    dau: 'दैनिक सक्रिय',
    mission_pct: 'मिशन %',
    broadcast: 'ब्रॉडकास्ट',
    broadcast_send: 'सूचना भेजें',
    edit_profile: 'प्रोफ़ाइल बदलें',
    save: 'सेव',
    theme_light: 'लाइट',
    theme_dark: 'डार्क',
    theme_system: 'सिस्टम',
    groups: 'ग्रुप्स',
    display_name: 'नाम',
    privacy: 'प्राइवेसी',
    public: 'सार्वजनिक',
    friends_only: 'सिर्फ़ दोस्त',
    private: 'निजी',
    welcome_back: 'फिर से स्वागत है',
    sign_in_signup: 'साइन इन / साइन अप',
    fast_easy: 'पासवर्ड नहीं। बस आपका फ़ोन।',

    // Goal Detail + Edit modal (iter-17)
    goal_details: 'लक्ष्य विवरण',
    edit: 'बदलें',
    active_goal: 'सक्रिय लक्ष्य',
    make_active: 'सक्रिय करें',
    why_this_matters: 'यह क्यों ज़रूरी है',
    extra_context: 'अतिरिक्त जानकारी',
    active_mission: 'सक्रिय मिशन',
    no_active_mission: 'अभी कोई सक्रिय मिशन नहीं।',
    activate_this_goal: 'इस लक्ष्य को सक्रिय करें',
    open_on_dashboard: 'डैशबोर्ड पर खोलें',
    mission_history: 'मिशन इतिहास',
    no_completed_missions: 'अभी कोई पूर्ण मिशन नहीं। पहला मिशन पूरा करें और यहाँ देखें।',
    completed_label: 'पूरा हुआ',
    skipped_label: 'छूट गया',
    archive_goal: 'इस लक्ष्य को आर्काइव करें',
    archive_confirm: 'इस लक्ष्य को आर्काइव करें? सक्रिय मिशन समाप्त हो जाएगा।',
    goal_archived: 'लक्ष्य आर्काइव हो गया',
    failed_archive: 'आर्काइव विफल',
    set_as_active: 'सक्रिय लक्ष्य के रूप में सेट किया',
    failed_switch: 'बदलाव विफल',
    saved: 'सेव हो गया',
    saved_new_mission: 'सेव हो गया — कोच ने नया मिशन बनाया',
    could_not_save: 'सेव नहीं हो पाया',
    could_not_load_goal: 'लक्ष्य लोड नहीं हो पाया',
    edit_goal: 'लक्ष्य बदलें',
    title_label: 'शीर्षक',
    timeline_days_label: 'समय (दिन)',
    importance_label: 'महत्व (1–10)',
    extra_details_label: 'अपने AI कोच के लिए अतिरिक्त विवरण',
    extra_details_placeholder: 'अपनी स्थिति, समय, सीमाओं आदि के बारे में नया कुछ भी।',
    reassess_checkbox: 'इन बदलावों के साथ नया मिशन बनाएँ',
    reassess_hint: 'विवरण या समय बदलने पर हम हमेशा नया विश्लेषण करते हैं।',
    save_changes: 'बदलाव सेव करें',
    saving: 'सेव हो रहा है…',
    day_plan_short: 'दिन योजना',
    tap_to_open_goal: 'टैप करें · पूर्ण मिशन देखें →',
    diff: 'कठिनाई',
    min_short: 'मिनट',

    // AddGoalWizard (iter-32)
    addgoal_pick_area: 'अपना क्षेत्र चुनें',
    addgoal_whats_goal: 'लक्ष्य क्या है?',
    addgoal_tap_suggestion: 'सुझाव चुनें या अपना लिखें',
    addgoal_title_placeholder: 'जैसे: रोज़ 5,000 कदम चलना',
    addgoal_tell_me_more: 'थोड़ा और बताइए',
    addgoal_coach_needs_details: 'आपका AI कोच कुछ विवरण चाहता है ताकि मिशन आपके लिए सही बने।',
    addgoal_coach_thinking: 'आपका कोच सोच रहा है…',
    addgoal_personalising: 'सवाल तैयार हो रहे हैं…',
    addgoal_answer_placeholder: 'आपका जवाब…',
    addgoal_how_long: 'कितना समय?',
    addgoal_how_important: 'कितना ज़रूरी?',
    addgoal_out_of_10: '10 में से',
    addgoal_create_goal: 'लक्ष्य बनाएं',
    addgoal_generating_first: 'आपका पहला मिशन तैयार हो रहा है…',
    addgoal_coach_reading: 'आपका AI कोच आपका लक्ष्य पढ़ रहा है — 5–10 सेकंड लगेंगे।',
    cat_group_wellness: 'सेहत और शरीर',
    cat_group_money: 'पैसा और करियर',
    cat_group_land: 'खेती और जीविका',
    cat_group_mind: 'मन और सीख',
    cat_group_other: 'कुछ और',
    cat_health: 'सेहत',
    cat_fitness: 'फिटनेस',
    cat_business: 'व्यवसाय',
    cat_sales: 'बिक्री',
    cat_money: 'पैसा',
    cat_savings: 'बचत',
    cat_education: 'पढ़ाई',
    cat_career: 'करियर',
    cat_relationships: 'रिश्ते',
    cat_travel: 'सफर',
    cat_habits: 'आदतें',
    cat_spiritual: 'आध्यात्मिक',
    cat_farming: 'खेती',
    cat_other: 'अन्य',
    sug_plan_season_crop: 'इस मौसम की फसल की योजना',
    sug_prepare_the_land: 'खेत तैयार करें',
    sug_buy_seeds_inputs: 'बीज और सामग्री खरीदें',
    sug_sow_on_time: 'समय पर बुवाई / रोपाई',
    sug_apply_fertilizer: 'सही खाद डालें',
    sug_manage_pests: 'कीट और रोग संभालें',
    sug_irrigate_smartly: 'समझदारी से सिंचाई',
    sug_harvest_on_time: 'समय पर कटाई',
    sug_better_selling_price: 'बेहतर बिक्री दाम पाएँ',
    sug_grow_farm_income: 'खेत से कमाई बढ़ाएँ',
  },
  te: {
    app_name: 'BecAim AI',
    tagline: 'మీరు లక్ష్యించినదిగా మారండి',
    enter_phone: 'మీ ఫోన్ నంబర్ నమోదు చేయండి',
    send_otp: 'OTP పంపండి',
    verify: 'ధ్రువీకరించండి',
    otp_label: 'OTP నమోదు చేయండి',
    next: 'తదుపరి',
    back: 'వెనుక',
    finish: 'ముగించండి',
    skip: 'దాటవేయి',
    age_group: 'మీ వయసు ఎంచుకోండి',
    gender: 'నేను',
    occupation: 'మీరు ఏం చేస్తారు?',
    goal_category: 'ఏ రంగం?',
    goal_specific: 'మీ లక్ష్యాన్ని ఎంచుకోండి',
    custom_goal: 'మీ స్వంత లక్ష్యం రాయండి',
    timeline: 'ఎంత కాలం?',
    importance: 'ఇది ఎంత ముఖ్యం?',
    your_mission: 'నేటి మిషన్',
    mark_complete: 'పూర్తయింది',
    skip_mission: 'దాటవేయి',
    reward: 'బహుమతి',
    streak: 'రోజుల వరుస',
    coins: 'నాణేలు',
    xp: 'XP',
    level: 'లెవల్',
    feed: 'ఫీడ్',
    home: 'హోమ్',
    coach: 'కోచ్',
    profile: 'ప్రొఫైల్',
    friends: 'స్నేహితులు',
    ask_coach: 'మీ కోచ్‌ని అడగండి…',
    ask: 'అడగండి',
    badges: 'బ్యాడ్జ్‌లు',
    leaderboard: 'లీడర్‌బోర్డ్',
    achievements: 'విజయాలు',
    logout: 'లాగౌట్',
    upload_proof: 'రుజువు అప్‌లోడ్ (ఐచ్ఛిక)',
    add_note: 'గమనిక జోడించండి (ఐచ్ఛిక)',
    confirm: 'నిర్ధారించండి',
    cancel: 'రద్దు',
    completed: 'పూర్తయింది!',
    earned_xp: 'మీరు సంపాదించారు',
    next_mission_ready: 'మీ తదుపరి మిషన్ సిద్ధం',
    level_up: 'లెవల్ అప్!',
    new_post: 'ఏం ఆలోచిస్తున్నారు?',
    post: 'పోస్ట్',
    no_posts: 'ఇంకా పోస్ట్‌లు లేవు. మొదటివారవ్వండి!',
    notifications: 'నోటిఫికేషన్లు',
    admin: 'అడ్మిన్',
    admin_panel: 'అడ్మిన్ ప్యానెల్',
    users: 'వాడుకర్లు',
    goals: 'లక్ష్యాలు',
    missions: 'మిషన్లు',
    total_users: 'మొత్తం వాడుకర్లు',
    active_7d: 'క్రియాశీలం (7 రో)',
    dau: 'రోజువారీ',
    mission_pct: 'మిషన్ %',
    broadcast: 'ప్రసారం',
    broadcast_send: 'నోటిఫికేషన్ పంపండి',
    edit_profile: 'ప్రొఫైల్ సవరించండి',
    save: 'సేవ్',
    theme_light: 'లైట్',
    theme_dark: 'డార్క్',
    theme_system: 'సిస్టమ్',
    groups: 'గ్రూపులు',
    display_name: 'ప్రదర్శన పేరు',
    privacy: 'గోప్యత',
    public: 'పబ్లిక్',
    friends_only: 'స్నేహితులు మాత్రమే',
    private: 'ప్రైవేట్',
    welcome_back: 'తిరిగి స్వాగతం',
    sign_in_signup: 'సైన్ ఇన్ / సైన్ అప్',
    fast_easy: 'పాస్‌వర్డ్ లేదు. కేవలం మీ ఫోన్.',

    // Goal Detail + Edit modal (iter-17)
    goal_details: 'లక్ష్యం వివరాలు',
    edit: 'సవరించు',
    active_goal: 'క్రియాశీల లక్ష్యం',
    make_active: 'క్రియాశీలం చేయి',
    why_this_matters: 'ఇది ఎందుకు ముఖ్యం',
    extra_context: 'అదనపు సమాచారం',
    active_mission: 'క్రియాశీల మిషన్',
    no_active_mission: 'ఇంకా క్రియాశీల మిషన్ లేదు.',
    activate_this_goal: 'ఈ లక్ష్యాన్ని క్రియాశీలం చేయండి',
    open_on_dashboard: 'డాష్‌బోర్డ్‌లో తెరవండి',
    mission_history: 'మిషన్ చరిత్ర',
    no_completed_missions: 'ఇంకా పూర్తయిన మిషన్లు లేవు. మొదటి మిషన్‌ను పూర్తి చేసి ఇక్కడ చూడండి.',
    completed_label: 'పూర్తయింది',
    skipped_label: 'దాటవేయబడింది',
    archive_goal: 'ఈ లక్ష్యాన్ని ఆర్కైవ్ చేయండి',
    archive_confirm: 'ఈ లక్ష్యాన్ని ఆర్కైవ్ చేయాలా? క్రియాశీల మిషన్ ముగుస్తుంది.',
    goal_archived: 'లక్ష్యం ఆర్కైవ్ చేయబడింది',
    failed_archive: 'ఆర్కైవ్ విఫలమైంది',
    set_as_active: 'క్రియాశీల లక్ష్యంగా సెట్ చేసారు',
    failed_switch: 'మార్పు విఫలమైంది',
    saved: 'సేవ్ అయింది',
    saved_new_mission: 'సేవ్ అయింది — కోచ్ కొత్త మిషన్‌ను సిద్ధం చేశారు',
    could_not_save: 'సేవ్ చేయలేకపోయాం',
    could_not_load_goal: 'లక్ష్యాన్ని లోడ్ చేయలేకపోయాం',
    edit_goal: 'లక్ష్యం సవరించండి',
    title_label: 'శీర్షిక',
    timeline_days_label: 'కాలవ్యవధి (రోజులు)',
    importance_label: 'ముఖ్యత (1–10)',
    extra_details_label: 'మీ AI కోచ్ కోసం అదనపు వివరాలు',
    extra_details_placeholder: 'మీ పరిస్థితి, షెడ్యూల్, పరిమితుల గురించి ఏదైనా కొత్తది.',
    reassess_checkbox: 'ఈ మార్పులతో కొత్త మిషన్‌ను రూపొందించండి',
    reassess_hint: 'వివరాలు లేదా కాలవ్యవధి మార్చితే మేము ఎల్లప్పుడూ తిరిగి అంచనా వేస్తాము.',
    save_changes: 'మార్పులను సేవ్ చేయండి',
    saving: 'సేవ్ అవుతోంది…',
    day_plan_short: 'రోజుల ప్రణాళిక',
    tap_to_open_goal: 'నొక్కండి · పూర్తయిన మిషన్లను చూడండి →',
    diff: 'కష్టత',
    min_short: 'నిమి',

    // AddGoalWizard (iter-32)
    addgoal_pick_area: 'మీ రంగాన్ని ఎంచుకోండి',
    addgoal_whats_goal: 'లక్ష్యం ఏమిటి?',
    addgoal_tap_suggestion: 'సూచనపై నొక్కండి లేదా మీదే రాయండి',
    addgoal_title_placeholder: 'ఉదా: ప్రతిరోజు 5,000 అడుగులు నడవండి',
    addgoal_tell_me_more: 'ఇంకా చెప్పండి',
    addgoal_coach_needs_details: 'మిషన్‌లను సరిగ్గా రూపొందించడానికి AI కోచ్‌కి కొన్ని వివరాలు కావాలి.',
    addgoal_coach_thinking: 'మీ కోచ్ ఆలోచిస్తున్నారు…',
    addgoal_personalising: 'ప్రశ్నలను సిద్ధం చేస్తున్నాం…',
    addgoal_answer_placeholder: 'మీ సమాధానం…',
    addgoal_how_long: 'ఎంత కాలం?',
    addgoal_how_important: 'ఎంత ముఖ్యం?',
    addgoal_out_of_10: '10కి',
    addgoal_create_goal: 'లక్ష్యం సృష్టించండి',
    addgoal_generating_first: 'మీ మొదటి మిషన్ సిద్ధం అవుతోంది…',
    addgoal_coach_reading: 'మీ AI కోచ్ మీ లక్ష్యాన్ని చదువుతున్నారు — 5–10 సెకన్లు పడుతుంది.',
    cat_group_wellness: 'ఆరోగ్యం & శరీరం',
    cat_group_money: 'డబ్బు & ఉద్యోగం',
    cat_group_land: 'వ్యవసాయం & జీవనోపాధి',
    cat_group_mind: 'మనస్సు & ఎదుగుదల',
    cat_group_other: 'ఇంకేదైనా',
    cat_health: 'ఆరోగ్యం',
    cat_fitness: 'ఫిట్‌నెస్',
    cat_business: 'వ్యాపారం',
    cat_sales: 'అమ్మకాలు',
    cat_money: 'డబ్బు',
    cat_savings: 'పొదుపు',
    cat_education: 'చదువు',
    cat_career: 'వృత్తి',
    cat_relationships: 'సంబంధాలు',
    cat_travel: 'ప్రయాణం',
    cat_habits: 'అలవాట్లు',
    cat_spiritual: 'ఆధ్యాత్మికం',
    cat_farming: 'వ్యవసాయం',
    cat_other: 'ఇతర',
    sug_plan_season_crop: 'ఈ సీజన్ పంటను ప్రణాళిక చేయండి',
    sug_prepare_the_land: 'భూమిని సిద్ధం చేయండి',
    sug_buy_seeds_inputs: 'విత్తనాలు & సామగ్రి కొనండి',
    sug_sow_on_time: 'సమయానికి విత్తనాలు / మొక్కలు నాటండి',
    sug_apply_fertilizer: 'సరైన ఎరువు వేయండి',
    sug_manage_pests: 'తెగుళ్ళు & వ్యాధులు అదుపు చేయండి',
    sug_irrigate_smartly: 'తెలివిగా నీరు పెట్టండి',
    sug_harvest_on_time: 'సమయానికి కోతలు',
    sug_better_selling_price: 'మంచి అమ్మకం ధర పొందండి',
    sug_grow_farm_income: 'వ్యవసాయంతో ఆదాయం పెంచండి',
  },
};

export const t = (lang, key) => (dict[lang] && dict[lang][key]) || dict.en[key] || key;
